import { render, staticRenderFns } from "./FormPartNaturalPerson.vue?vue&type=template&id=551744ec&scoped=true"
import script from "./FormPartNaturalPerson.vue?vue&type=script&lang=js"
export * from "./FormPartNaturalPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551744ec",
  null
  
)

export default component.exports